export default __webpack_public_path__ + "static/media/mdex.c0e0d847.svg";